import React from 'react';
import RightSidebarForm from 'Views/Page/Content/RightSidebar/Content/RightSidebarForm';
import PropTypes from 'prop-types';
import whatIfMetaOverrideSet from './WhatIfMetaOverrideSet';
import facetPlanAddScenarioOverrideSet from './FacetPlanAddScenarioOverrideSet';
import metaOverrideSet from './MetaOverrideSet';
import layout from './Layout';

const metaOverrideMap = {
  facetPlan: facetPlanAddScenarioOverrideSet,
  FacetPlanProposal: whatIfMetaOverrideSet,
};

const DefaultTemplate = ({
  collection,
}) => {
  let metaOverride = metaOverrideMap[collection.meta().type()];
  if (!metaOverride) {
    metaOverride = metaOverrideSet;
  }

  return (
    <RightSidebarForm
      Layout={layout}
      collection={collection}
      metaOverrideSet={metaOverride}
    />
  );
};

DefaultTemplate.propTypes = {
  collection: PropTypes.object.isRequired,
};

export default DefaultTemplate;
